import {useEffect} from 'react'
import {createMarkerClass} from './StationCustomMaker'
import {getGoogleMapsClass, IMaps} from './mapsUtil'
import React from 'react'

export interface IOverlay {
  price: number
  lat: number
  lng: number
  onClick?: () => any
  isCamp: boolean
  activityOnly: boolean
  zoom?: number
}

const StationMapsOverlay = (
  {
    maps,
    price,
    lat,
    lng,
    onClick,
    isCamp,
    activityOnly,
    zoom
  }: {
    maps: IMaps
  } & IOverlay) => {
  useEffect(() => {
    const MarkerClass = createMarkerClass(getGoogleMapsClass().OverlayView)
    const marker = new MarkerClass(maps, price, activityOnly, isCamp, { lat, lng }, onClick)
    return () => {
      marker.onRemove()
    }
  }, [zoom, lat, lng])
  return null
}
StationMapsOverlay.displayName = 'StationMapsOverlay'
export default StationMapsOverlay
